var map = {
	"./empty-activity.svg": 93817,
	"./empty-blacklist.svg": 63835,
	"./empty-chapters.svg": 76492,
	"./empty-courses.svg": 48309,
	"./empty-crawler.svg": 15148,
	"./empty-graphs.svg": 11005,
	"./empty-items.svg": 39082,
	"./empty-materials-plan.svg": 4450,
	"./empty-materials-watch.svg": 40234,
	"./empty-materials.svg": 73695,
	"./empty-objectives.svg": 79526,
	"./empty-options.svg": 35545,
	"./empty_courses.svg": 88634,
	"./empty_material.svg": 49931,
	"./empty_objects.svg": 96690,
	"./empty_questions.svg": 24469,
	"./waiting_object.svg": 34628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68073;